export const IT = {
  message: {
    banner:
      "Due to a technical issue, all the data cannot be published. We are working on it. We apologise for the inconvenience.",
    in: "En",
    loadingText: "Caricamento in corso ...",
    selectCustomer: "selezionare un cliente",
    offline: "Sito in manutenzione",
    refer: "Fare riferimento alle condizioni di utilizzo",
    error: {
      userNotFound: "Aucun utilisateur trouvé",
      noToken: "Ce lien n'est plus valide",
    },
    alert: {
      mail: "Activer alerte mail",
      sms: "Activer alerte SMS",
      battery: "parametri definiti",
      disclamer:
        "da Akiem Leasing e relativi a locomotive dotate di box Railster",
      sralert: "Allarme",
      toggleAlert:
        "Attivando questa opzione, riceverai una notifica via email per ogni avviso inviato da MyFleetHub",
      quotation: "Quotation alert",
      quotationLabel:
        "attivando questa opzione, si riceverà una notifica e-mai per ogni nuovo preventivo pubblicato su MyFleetHub",
    },
    select: "Tout cocher",
    ssoLogin: "Accedere con azure AD",
    rgpd:
      "Akiem si impegna a rispettare in modo equo e trasparente la legislazione sulla protezione dei dati personali, in particolare " +
      'il Regolamento Generale sulla Protezione dei Dati (il "GDPR"). Su questo portale non utilizziamo cookies. Pertanto, nessuno ' +
      "dei vostri dati personali sarà raccolto durante la vostra sessione di accesso o memorizzato dopo la sua conclusione. " +
      'Le verrà chiesto il suo consenso se desidera utilizzare la funzione "sondaggio di soddisfazione".',
    login: {
      welcomeFirst: "Benvenuto nel tuo",
      welcomeSecond: "espace client",
      id: "Login",
      pw: "La mia password",
      restore: "Ripristinare la mia password",
      validate: "Convalidare",
      errorLogin: "Le mot de passe est éronné, merci de recommencer",
      initMsg:
        "Veuillez renseigner votre mot de passe pour finaliser la creation de votre compte",
    },
    aside: {
      home: "Casa",
      notice: "Guida utente",
      logout: "Logout",
      account: "Il mio account",
      config: "Configuration",
      profil: "Informazioni sul profilo",
      alert: "Mes alertes",
      parc: "La mia flotta",
      planning: "Mon planning",
      detail: "Dettagli della mia flotta",
      geo: "Geolocalizzazione rotabili",
      board: "Dashboard",
      km: "Monitoraggio chilometri percorsi",
      hm: "Ore motore",
      battery: "Info batterie",
      mint: "My MINT",
      magic: "Maintenance Interventions",
      history: "Storico interventi",
      infoloc: "Info locomotiva",
      fleetcontrol: "Controllo flotta",
      unleased: "Flotta non in leasing",
      doc: "La mia documentazione",
      edl: "Stato di fatto / Certificati",
      certificat: "Certificati",
      jobplan: "Manutenzioni future",
      krefeldplan: "Krefeld plan",
      batterytable: "Ultime rilevazioni batteria",
      geofencing: "Geofencing",
      disponibility: "Disponibilità contrattuale",
      admin: "Internal menu",
      locoInternal: "Creare un ticket di assistenza",
      userlist: "Elenco utenti",
    },
    superuser: {
      profile: "Profilo",
      action: "Azione",
      updateprofile: "Edizione",
      administrator: "Amministratore",
      management: "Gestione",
      operational: "Operativo",
      commercial: "Commerciale",
      delmessage1: "Si sta per richiedere la cancellazione dell'account",
      delmessage2:
        "Verrà inviato un messaggio al reparto IT di Akiem che eliminerà l'account.",
      delmessage3:
        "non avrà più accesso al portale clienti My Fleet hub. Se l'utente desidera ricreare un account in un secondo momento, deve contattare il responsabile del contratto di assistenza. Desidera continuare?",
      legendmgt:
        "Il profilo di gestione può consultare tutti i moduli del portale. Possono convalidare il lavoro extra.",
      legendcom:
        "Il profilo commerciale può consultare tutti i moduli del portale. Non può convalidare il lavoro extra.",
      legendoper:
        "Il profilo operativo può consultare tutti i moduli del portale tranne il modulo « Il mio lavoro extra ».",
    },
    geofencing: {
      select: "Selezionare un valore",
      entry: "Data e ora di ingresso",
      exit: "Data e ora di uscita",
      dbenergy: "Avete pensato di fare la vostra dichiarazione DB Energy?",
    },
    header: {
      language: "Lingue",
    },
    home: {
      team: "I miei contatti in Akiem",
      name: "Cognome",
      firstname: "Nome",
      function: "Funzione",
      fixphone: "Tel fisso",
      mobilephone: "Telefono cellulare",
      mail: "E-mail",
      locoInfo: "Crea una richiesta di assistenza rapida",
    },
    page: {
      assignment: "Assegnazione",
      customer: "Portail",
      portal: "Client",
      availableLoco: "Mantenuta da AKIEM",
      loconumber: "Numero di locomotive",
      status: "Stato operativo",
      available: "Disponible",
      maintenance: "In manutenzione",
      connexionDate: "Data dell'ultima connessione",
      findLocation: "Trovare la posizione del materiale rotabile",
      contractNumber: "Numero di contratto",
      serial: "Série",
      contractStatus: "Status contrattuale",
      startDate: "Data di inizio",
      endDate: "Data di fine",
      delta:
        "En sélectionnant une plage de dates, vous obtiendrez un tracé de votre parcours",
      locate: "Posizione",
      titular: "Titolare",
      reserve: "Riserva",
      spot: "Spot",
      performance: "Performance",
      cumulTitle: "Kilomètres cumulés par locomotive",
      cumul: "km cumulativi",
      distance: "Distanza",
      moyMonth: "km medi percorsi / mese",
      filterMsg:
        "Selezionando una singola locomotiva si ottiene la mappa del percorso",
      availableNotice: '"Ne comprend pas les signalements en compte"',
      doctype: "Tipo di documento",
      contractType: "Contract type",
    },
    opinionGlobal: {
      opinion: "La mia opinione sul portale",
      opinionFirst: "Mia opinione",
      opinionSecond: "sul portale",
      opinionRedirectionOne: "sarai reindirizzato ad una pagina esterna,",
      opinionRedirectionTwo: " vuoi continuare?",
      opinionClic:
        "Cliccando su questo link, lei accetta di lasciare questo portale per accedere alla piattaforma " +
        "Eval N Go per questa indagine di soddisfazione e quindi acconsente al trattamento dei suoi dati personali.",
      opinionPersonelData: "I dati personali raccolti sono i seguenti :",
      opinionMail: "Indirizzi e-mail",
      opinionName: "Nome",
      opinionDataTransmission:
        "Questi dati vengono trasmessi solo alle persone autorizzate da Akiem, " +
        "soggette all'obbligo di riservatezza, e vengono conservati per 1 anno.",
      opinionStock:
        "È ospitato in Francia e non sarà trasmesso al di fuori dell'UE.",
      opinionRules:
        "In conformità con la legge in vigore, avete il diritto di controllare i vostri dati " +
        "personali (diritto di accesso, rettifica, ecc.) che potete esercitare inviando una e-mail a dpo@akiem.com",
      opinionHelp:
        "Questo ci aiuta a fare ulteriori progressi nel modo in cui vi sosteniamo e a capire meglio " +
        "le vostre esigenze, il vostro contributo sarebbe un aiuto prezioso.",
      opinionYes: "Si",
      opinionNo: "No",
    },
    pageKm: {
      trackingKm: "Suivi des kilomètres",
      tableKm: "Tableau des kilomètres",
      status: "Status contrattuale",
      serial: "Numero di serie",
      contract: "Contrats",
      contractnum: "Numero di contratto",
      total: "Distanza totale",
      loco: "Locomotive",
      date: "Data",
      since: "Da",
      kmNotice: '"Kilomètres relevés selon les données Railster transmises" ',
    },
    pageHm: {
      title: "Ore motore",
      lastcheck: "Ultimi dati",
      cumulativeHm: "Ore motore cumulate",
      hm: "Ore motore",
      total: "Ore totali del motore consumate",
      portalReal: "Letture effettuate dal portale",
      maintenanceReal: "Letture effettuate durante la manutenzione",
      detailHm: "Dettagli sulle ore del motore",
    },
    maintenance: {
      workshops: "Officine",
    },
    pageAlert: {
      alert: "Mes alertes",
      inout: "ENTREE ET SORTIE LOCOMOTIVE",
      serial: "Sur une série",
      contract: "Sur un contrat",
      loco: "Sur les locs de mon parc",
      mail: "Activer alertes mail",
      sms: "Activer alertes sms",
      battery: "ALERTES BATTERIE",
    },
    passwordResetPage: {
      first: "Veuillez renseigner votre mot de passe",
      confirm: "mot de passe confirmation",
      pwRuleOne: "mot de passe requis",
      pwRuleTwo: "8 caractères minimum",
      pwRuleThree:
        "Le mot de passe doit contenir au moins une lettre minuscule, un chiffre, un caractère spécial et une lettre majuscule",
      pwConfirmOne: "la confirmation du mot de passe est requise",
      pwConfirmTwo: "La confirmation du mot de passe ne correspond pas",
      pwSuccess: "Mot de passe reinitialisé avec success",
      validate: "Valider",
    },
    pageNotice: {
      second:
        "I dati, le informazioni e/o i documenti che compaiono su questo Portale e/o disponibili attraverso questo Portale, " +
        "sono pubblicati unicamente a titolo indicativo e informativo e non hanno valore contrattuale.",
      third:
        "Tali dati, informazioni e/o documenti possono contenere inesattezze ed errori. Akiem si riserva di poterli modificare " +
        "in qualsiasi momento ed essi potrebbero essere oggetto di aggiornamenti. Si raccomanda caldamente di verificare l’esattezza " +
        "e la pertinenza dei dati, delle informazioni e/o dei documenti messi a disposizione su questo Portale.",
      fourty:
        "L’Utente del Portale utilizza i dati, le informazioni e/o i documenti disponibili su questo Portale sotto la propria " +
        "intera ed esclusiva responsabilità e si assume l’integralità delle conseguenze che potrebbero derivare da tale utilizzazione, " +
        "esonerando Akiem da qualsiasi responsabilità a tal titolo, e senza alcuna possibilità di ricorso nei confronti di Akiem.",
      fifty:
        "Akiem non potrà in alcun caso essere ritenuta responsabile di eventuali danni di qualunque tipo derivanti da " +
        "un’interpretazione o dall’utilizzazione delle informazioni e/o dei documenti disponibili su questo Portale.",
      sixty:
        "Il Portale è normalmente accessibile, per gli Utenti dotati di accesso internet, 24 ore su 24 e 7 giorni su 7, salvo in caso " +
        "di forza maggiore o qualora si verificasse un evento che esula dal controllo di Akiem e fatti salvi eventuali guasti, nonché gli " +
        "interventi manutentivi necessari al corretto funzionamento del Portale. Akiem si riserva la facoltà di interrompere, in qualsiasi " +
        "momento e senza preavviso, di sospendere momentaneamente o di modificare l’accesso al Portale in totalità o in parte, allo scopo di poterne " +
        "garantire la manutenzione, o per qualunque altra ragione, senza che l’interruzione possa dare diritto ad una qualsivoglia obbligazione o ad un qualsiasi indennizzo.",
      seventy:
        "Akiem si impegna a rispettare in modo equo e trasparente la legislazione sulla protezione dei dati personali ed, in particolare, il Regolamento Generale " +
        "sulla Protezione dei Dati (cosiddetto « GDPR »). Akiem ha messo in opera le misure tecniche e organizzative idonee ai fini della protezione dei dati dell’Utente " +
        "contro gli accessi non autorizzati e contro qualunque altro rischio relativo alla sicurezza e alla vulnerabilità informatica.",
      eighty:
        "Sul presente Portale non facciamo uso di cookie. Pertanto, durante la sua sessione di accesso, non verrà raccolto nessuno dei suoi dati personali, ed al termine " +
        "di tale sessione nessuno dei suoi dati verrà memorizzato. Qualora desiderasse utilizzare la funzionalità “indagine di soddisfazione”, le verrà espressamente richiesto il suo consenso.",
    },
    magic: {
      workorderTitle: "Titolo dell'intervento",
      workorder: "Intervento",
      startDate: "Data di inizio",
      endDate: "Data di fine",
      meter: "Chilometri",
      hours: "Ore motore",
      technicDoc: "Documentazione tecnica",
      restriction: "Restriction/Reason",
      date: "Data",
      asset: "Materiel roulant",
      km: "KM",
      leftD1: "D1 gauche",
      leftD2: "D2 gauche",
      leftD3: "D3 gauche",
      leftD4: "D4 gauche",
      rightD1: "D1 droit",
      rightD2: "D2 droit",
      rightD3: "D3 droit",
      rightD4: "D4 droit",
      action: "Action",
      description: "Rescrizione - Posizione",
      desc: "Rescrizione",
      addFile: "Aggiungere un allegato",
      reportBy: "Signalé par",
      id: "ID",
      status: "Status",
      sr: "Ticket",
      srAttechement: "avvisi correlati",
      attachements: "Allegati",
      mileage: "Chilometraggio",
      createAlert: "Apertura Ticket",
      title: "Titolo",
      location: "Posizione",
      priority: "Priorità",
      addKm: "Inserire dati utilizzo veicoli",
      newKm: "Nuovo valore",
      lastreading: "Valore attuale",
      scheduleDate: "Data pianificata",
      metername: "Dati (Ore motore / Km)",
      executeDate: "Date di esecuzione",
      error: "Operazione annullata",
      success: "L'operazione è stata registrata",
      attachment: "Aggiungere un allegato",
      unit: "Unità",
      source: "Fonte",
      jobplan: "Job plan type",
      type: "Típo",
      reportedDate: "Data di creazione",
      details: "Dettagli",
      hotline: "Biglietto hotline",
    },
    assetStatus: {
      operating: "Operating",
      maintenance: "Maintenance",
      limitedUse: "limited use",
      blocked: "Blocked",
    },
    button: {
      submit: "Cvalidare",
      cancel: "Annulla",
    },
    search: "Cerca",
    history: {
      pm: "Storico degli interventi correttivi",
      cm: "Storico degli interventi preventivi",
    },
    infoloc: {
      infoOp: "Informazioni operative",
      infoTech: "Informazioni tecniche",
      cert: "Omologazione",
      openSr: "Signalements ouverts",
      sr: "Tickets",
      dateAndKm: "Date e chilometraggio",
      pmPlan: "Plan de maintenance prévisionnelle",
      locomotive: "Locomotive",
      actWorkorder: "Intervento in corso",
      outPrevDate: "Data prevista di uscita",
      nextWorkDate: "Prossima manutenzione",
      wheelset: "Misure ruote",
      unitToGo: "Chilometri restanti",
      engineeringvariant: "Engineering variant",
      softwareversion: "Software version",
      hkm: "storia del chilometraggio",
      hhm: "cronologia delle ore motore",
      fuellevel: "Livello fioul",
      parking: "Inattiva",
      traction: "In movimento - Trazione",
      vehicle: "In movimento - Loco trainata",
      poweron: "Acceso, senza movimento",
      standby: "Motore diesel acceso senza movimento",
    },
    status: {
      approved: "Confirmed appointment",
      canceled: "Cancellato",
      ccanceled: "Appointment canceled by customer",
      completed: "Status according desicion ECM 3",
      inprogress: "Under maintenance",
      wait: "forcast planing, upcoming maintenance",
      new: "Nuovo",
      sinprogress: "In corso",
      closed: "Chiuso",
    },
    woStatus: {
      WSCH: "In attesa di conferma della data esatta ",
      WAPPR: "In attesa di conferma della data esatta ",
      WPCOND: "In attesa di conferma della data esatta ",
      CLOSE: "Realizzata",
      COMP: "Realizzata",
      INPRG: "In corso",
      REVIEWED: "In attesa di liberazione par ECM3",
      WCOE: "In attesa del prezzo o del materiale",
      WMATL: "In attesa del prezzo o del materiale",
      APPR: "Approvata",
      CA: "Annulata",
      NOTPERF: "Non realizzata",
      CAN: "Annulata",
    },
    doc: {
      certificat: {
        delivry: "CERTIFICATO DI CONSEGNA",
        redelivry: "CERTIFICATO DI RESTITUZIONE",
        genralInfo: "INFORMAZIONI GENERALI",
        technicalInfo: "CONTATORI",
        signature:"FIRME",
        asOf:"a partire dal",
        andAccording: "e in conformità con le disposizioni del",
        contractRes: "contratto/adendum riferimento ",
        representBy:"della società Akiem SAS, rappresentata da Sebastian Rodriguez",
        delivryTo: "consegna alla società",
        society:"la the company",
        lessee: " (hereinafter the LESSEE) ",
        delivryToAkm:"ha restituito ad Akiem, rappresentata da Sebastian Rodriguez ",
        locomotive: "la locomotiva",
        locoType: "Tipo di locomotiva",
        delivryAt: "presso il sito di ",
        redelivryAt:"che è stata accettata dal locatore presso il sito di ",
        restDerog:"Restrizioni/Uso limitato",
        comment:"Commenti",
        edl:"Documento di consegna allegato",
        remark:"Nota",
        rem1:"Fatto salvo quanto previsto contrattualmente, questa locomotiva deve essere assicurata al più tardi dalla data di consegna indicata nel certificato.",
        rem2:"*La custodia della locomotiva passa al locatario alla data di consegna indicata in questo certificato.",
        kmCompteur: "Km contachilometri",
        hmMoteur: "Ore motore",
        wheelset: "Assi",
        recentData: "Dati più recenti*",
        subjectTo: "*Salvo inventario di stato, se applicabile.",
        lastRecord: "ultima registrazione il",
        date:"Data",
        defaultMes:"Se non viene ricevuta alcuna riserva entro 48 ore, questo certificato sarà considerato definitivo.",
        addBill:"Potrebbero essere addebitati costi aggiuntivi per il ripristino della locomotiva.",
        yes: "YES",
        no: "NO",
        reserv: "To send a reserve",
        reject: "Reserves issued",
      },
      type: "Tipo di documento",
      edl: {
        delivry: "Dichiarazione di consegna",
        redelivry: "Dichiarazione di consegna ",
      },
    },
    doctypes: [
      {
        key: "DELIVERY (EXCEPT NEW)",
        value: "Dichiarazione di consegna",
      },
      {
        key: "REDELIVERY,RESTITUTION",
        value: "Dichiarazione di consegna",
      },
      {
        key: "Prima Delivery Certificate,Traxx Delivery Certificate",
        value: "Certificati di consegna",
      },
      {
        key: "Prima Redelivery Certificate,Traxx Redelivery Certificate",
        value: "Certificati di restituzione",
      },
    ],
    poi: {
      workshop: "Laboratori su ingressi/uscite",
      entry: "Entrata stimata il",
      exit: "Uscita stimata al",
      at: "alle ore",
    },
    extrawork: {
      title: "Il mio Extra-work",
      newquote: "Nuovi preventivi",
      quotewaiting: "In attesa di convalida",
      messageconfirm: "Inserire il numero d'ordine",
      confirm: "Confermare",
      reject: "Rifiutare",
      cancel: "Annullare",
      whyreject: "Perché volete rifiutare il preventivo?",
      rejectcomment: "Lasciate un commento",
      quotenum: "Preventivo n.",
      quotetitle: "Titolo dell'offerta",
      quoteprice: "Prezzo IVA escl.",
      quotestatus: "Stato dell'offerta",
      realisationdate: "Realizzazione effettiva",
      customerpo: "N° ordine cliente",
      tovalidate: "In attesa di convalida",
      validated: "Accettato",
      rejected: "Rifiutato",
      quoterejected: "Rifiutato",
      quotesrejected: "Preventivi rifiutati",
      comment: "Commenti",
      unitprice: "Prezzo unitario",
      service: "Servizi",
      quantity: "Quantità",
      totalprice: "Prezzo totale",
      quotetotalprice: "Costo totale dell'offerta",
      statusbilled: "fatturato",
      statusvalidated: "Convalidato",
    },
    dispoc: {
      past: "Consultare le assegnazioni precedenti",
      widgetText: "Vedi la mia disponibilità contrattuale",
      taux: "Percentuale",
      recapLoc: "Disponibilità",
      ticmp: "Percentuale di fermo loco per preventiva",
      timcc: "Percentuale di fermo loco per correttiva",
      ticc: "Percentuale di fermo loco per responsabilità cliente",
      locDisp: "Disponibile",
      locTot: "Totale",
      week: "Settimana",
      ldispo: "Disponibile",
      ldmd: "Disponibile in modalità degradata",
      lmp: "Manutenzione preventiva",
      lmc: "Corrective maintenance",
      lach: "Trasporto",
      lmcc: "M. correttiva responsabilità cliente",
      indisponibilite: "Indisponibilità",
      dispGen: "Disponibilità globale",
      causeCorrective: "manutenzione correttiva",
      causePreventive: "manutenzione preventiva",
      causeClient: "del cliente",
    },
    restriction: {
      title: "Restrizioni in",
      partial: "Restrizioni parziali",
      total: "Restrizioni totali",
      dates: "Dal {start} al {end}",
    },
  },
  country: {
    AT: "Austria",
    BE: "Belgio",
    CH: "Svizzera",
    CZ: "Repubblica Ceca",
    DE: "Germania",
    DK: "Danimarca",
    FR: "Francia",
    HR: "Croazia",
    HU: "Ungheria",
    IT: "Italia",
    LU: "Lussemburgo",
    MA: "Marocco",
    NL: "Paesi Bassi",
    PL: "Polonia",
    RO: "Romania",
    SE: "Svezia",
    SK: "Slovacchia",
    SI: "Slovenia",
    RS: "Serbia"
  },
};

export default IT;
